export default "__VITE_ASSET__45c507e3__"